import { createSlice } from '@reduxjs/toolkit'
import { attendancePolicy } from '../../../reduxModels';

const initialState: attendancePolicy = {
    attendancePolicyList: [],
    compnayList: [],
    actionAndPolicyDetails: {},
    regularizationPolicyDetails: {},
    company_name: "",
    updated_at: "",
    created_at: "",
    deleted_at: "",
    refresh: false,
    deletePolicyName: "",
    attendance_policy:"", //"yes" || "no"
    regularization_policy :""//"yes" || "no"
}

const attendancePolicySlice = createSlice({
    name: 'attendancePolicy',
    initialState,
    reducers: {
        setAttendancePolicy: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setAttendancePolicy } = attendancePolicySlice.actions;

export default attendancePolicySlice.reducer